import { render, staticRenderFns } from "./BackImageTab.vue?vue&type=template&id=83c5a8c8&scoped=true&"
import script from "./BackImageTab.vue?vue&type=script&lang=js&"
export * from "./BackImageTab.vue?vue&type=script&lang=js&"
import style0 from "./BackImageTab.vue?vue&type=style&index=0&id=83c5a8c8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c5a8c8",
  null
  
)

export default component.exports